<template>
  <div class="news-page">
    <AppHeader />

    <main class="main-content">
      <img
        class="hero-bg"
        src="https://hfqsyl.oss-cn-hangzhou.aliyuncs.com/img/web20260731160938656.jpg"
        alt="资讯中心"
      />
      <div class="text-content">
        <h1>资讯中心</h1>
        <p>关注千手医疗最新动态</p>
      </div>
    </main>

    <section class="news-section">
      <div class="news-container">
        <div class="news-section__header">
          <h2 class="news-section__title">全部资讯</h2>
          <div class="module-underline"></div>
          <p class="news-section__desc">点击查看详情</p>
        </div>

        <div v-if="loading" class="news-page-empty">加载中...</div>
        <div v-else-if="!list.length" class="news-page-empty">暂无资讯</div>
        <div v-else class="news-page-list">
          <article
            v-for="item in list"
            :key="item.id"
            class="news-page-card"
            @click="goDetail(item)"
          >
            <img
              v-if="item.coverUrl"
              class="news-page-card__cover"
              :src="formatImg(item.coverUrl)"
              :alt="item.title"
            />
            <div class="news-page-card__body">
              <h3 class="news-page-card__title">{{ item.title }}</h3>
              <p class="news-page-card__summary">{{ getSummary(item) }}</p>
              <div class="news-page-card__meta">
                <span>{{ item.company }}</span>
                <span> | {{ formatDate(item.publishTime) }}</span>
                <span> | {{ item.region }}</span>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import { getNewsArticles } from '@/api/newsArticles'
import { formatImg } from '@/utils/formatImg'

export default {
  name: 'NewsCenter',
  components: { AppHeader, AppFooter },
  data() {
    return {
      loading: false,
      list: []
    }
  },
  methods: {
    formatImg,
    formatDate(value) {
      if (!value) return ''
      return String(value).slice(0, 10)
    },
    getSummary(item) {
      if (item?.summary) return item.summary
      if (!item?.content) return ''
      try {
        const blocks = typeof item.content === 'string' ? JSON.parse(item.content) : item.content
        if (Array.isArray(blocks)) {
          const firstText = blocks.find((b) => b?.type === 'text' && b.text)
          return firstText?.text || ''
        }
      } catch (e) {
        // ignore
      }
      return String(item.content)
    },
    goDetail(item) {
      if (!item?.id) return
      window.scrollTo(0, 0)
      this.$router.push({
        name: 'NewsDetail',
        query: { id: item.id }
      })
    },
    async loadList() {
      this.loading = true
      try {
        const data = await getNewsArticles()
        this.list = Array.isArray(data) ? data : []
      } catch (e) {
        console.error('加载资讯列表失败', e)
        this.list = []
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'auto' })
    this.loadList()
  }
}
</script>

<style scoped>
@import url(../../style/news/news-list.css);
@import url(../../style/home/homepage.css);
</style>
